import React from 'react';
import { Platformbutton } from 'components/common/button/button';
import Inputfloat from 'components/common/inputs/inputfloat';
import {
  CustomizedSingleselect,
  Singleselect,
} from 'components/common/inputs/singleselect';

export const IdentityVerification = props => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
        alignItems: 'center',
      }}
    >
      <p
        style={{
          fontSize: '22px',
          fontWeight: '700',
          width: '100%',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          paddingTop: '5rem',
        }}
      >
        Verify your identity
      </p>
      <p
        style={{
          color: '#111827',
          fontSize: '14px',
          fontWeight: '300',
          marginBottom: '20px',
        }}
      >
        To give you access to financial services like debit card loans, and
        wallet account, we need your government ID numbers.
      </p>

      <div
        style={{
          display: 'flex',
          flexDirection: 'column',
          width: '100%',
          gap: '20px',
        }}
      >
        <Singleselect
          //   value={''}
          options={
            'hello'
            //     gender.map((op, index) => ({
            //     key: index,
            //     label: op.opt,
            //     value: op.opt,
            //   }))
          }
          placeholder={`Identification document`}
          onChange={
            ''
            //     selectedValue => {
            //     handleSelect('gender', selectedValue.value);
            //   }
          }
          name="gender"
        />
        <Inputfloat
          label="Identification number"
          type="text"
          name="text"
          // value={values.password}
          disabled={false}
          placeholder="Identification number"
          // onChange={handleChange}
          // invalid={errors.password && touched.password && 'true'}
          // error={
          //   errors.password && touched.password ? errors.password : ''
          // }
        />
      </div>

      <Platformbutton
        name="Verify"
        type="submit"
        disabled={false}
        click={() => {
          props.setStep(4);
        }}
      />
    </div>
  );
};
